module.exports = __webpack_public_path__ + "9ed2c6618add1105b5f5ba1633fa6e6e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/ALLEYESONUS2.jpg
// module id = 597
// module chunks = 0